<template>
  <div class="auth-wrapper">
    <b-row class="auth-inner m-0 justify-content-center">
      <b-col
        md="8"
        lg="6"
      >
        <div class="text-center my-2">
          <b-link :to="{ name: 'home' }">
            <img
              src="@/assets/images/logo/verolabs-logo.png"
              alt="VEROlabs Logo"
              class="register-test-logo"
            >
          </b-link>
        </div>
        <b-card class="bg-transparent border-0">
          <b-col
            sm="12"
            md="12"
            lg="12"
            class="px-xl-2 mx-auto"
          >
            <validation-observer
              ref="registerForm"
              #default="{ invalid }"
            >
              <b-form
                class="auth-register-form mt-2"
                @submit.prevent="register_test"
              >
                <b-row class="g-2">
                  <!-- First Name -->
                  <b-col class="col-6 mb-1">
                    <b-form-group
                      label="First Name"
                      label-for="register-firstname"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="First Name"
                        vid="firstname"
                        rules="required"
                      >
                        <div class="input-icon-wrapper">
                          <feather-icon
                            icon="UserIcon"
                            class="field-icon"
                            size="20"
                          />
                          <b-form-input
                            id="register-firstname"
                            v-model="firstName"
                            :state="errors.length > 0 ? false : null"
                            placeholder="John"
                          />
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- Last Name -->
                  <b-col class="col-6 mb-1">
                    <b-form-group
                      label="Last Name"
                      label-for="register-lastname"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Last Name"
                        vid="lastname"
                        rules="required"
                      >
                        <div class="input-icon-wrapper">
                          <feather-icon
                            icon="UserIcon"
                            class="field-icon"
                            size="20"
                          />
                          <b-form-input
                            id="register-lastname"
                            v-model="lastName"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Smith"
                          />
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- Email -->
                  <b-col class="col-6 mb-1">
                    <b-form-group
                      label="Email"
                      label-for="register-email"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Email"
                        vid="email"
                        rules="required|email"
                      >
                        <div class="input-icon-wrapper">
                          <feather-icon
                            icon="MailIcon"
                            class="field-icon"
                            size="20"
                          />
                          <b-form-input
                            id="register-email"
                            v-model="userEmail"
                            :state="errors.length > 0 ? false : null"
                            placeholder="john@example.com"
                          />
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- Institution Code -->
                  <b-col class="col-6 mb-1">
                    <b-form-group
                      label="Enrolment Code"
                      label-for="register-institutionCode"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Enrolment Code"
                        vid="institutionCode"
                        rules="required"
                      >
                        <div class="input-icon-wrapper">
                          <feather-icon
                            icon="CodeIcon"
                            class="field-icon"
                            size="20"
                          />
                          <b-form-input
                            id="register-institutionCode"
                            v-model="institutionCode"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Enrolment Code"
                          />
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- Password -->
                  <b-col class="col-6 mb-1">
                    <b-form-group
                      label-for="register-password"
                      label="Password"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Password"
                        vid="password"
                        rules="required"
                      >
                        <div class="input-icon-wrapper">
                          <feather-icon
                            icon="UnlockIcon"
                            class="field-icon"
                            size="20"
                          />
                          <b-form-input
                            id="register-password"
                            v-model="password"
                            class="form-control-merge"
                            :type="passwordFieldType"
                            :state="errors.length > 0 ? false : null"
                            placeholder="············"
                          />
                          <feather-icon
                            class="cursor-pointer show-pass-icon"
                            :icon="passwordToggleIcon"
                            @click="togglePasswordVisibility"
                          />
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- Confirm Password -->
                  <b-col class="col-6 mb-1">
                    <b-form-group
                      label-for="register-confirm-password"
                      label="Confirm Password"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Confirm Password"
                        vid="confirm-password"
                        rules="required|confirmed:password"
                      >
                        <div class="input-icon-wrapper">
                          <feather-icon
                            icon="UnlockIcon"
                            class="field-icon"
                            size="20"
                          />
                          <b-form-input
                            id="register-confirm-password"
                            v-model="confirmPassword"
                            class="form-control-merge"
                            :type="passwordFieldType"
                            :state="errors.length > 0 ? false : null"
                            placeholder="············"
                          />
                          <feather-icon
                            class="cursor-pointer show-pass-icon"
                            :icon="passwordToggleIcon"
                            @click="togglePasswordVisibility"
                          />
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Buttons -->
                <div>
                  <b-row>
                    <b-col
                      md="12"
                      class="mb-1"
                    >
                      <b-button
                        type="submit"
                        variant="primary"
                        class="w-100 d-flex align-items-center justify-content-center p-0 py-50 cursor-pointer"
                        :disabled="invalid || isLoading"
                      >
                        <feather-icon
                          icon="CheckIcon"
                          size="20"
                          class="mr-1"
                        />
                        <span v-if="!isLoading">Signup</span>
                        <b-spinner
                          v-if="isLoading"
                          type="grow"
                          small
                          class="ml-1"
                        />
                      </b-button>
                    </b-col>
                    <!-- <b-col md="12">
                      <b-button
                        variant="secondary"
                        :to="{ name: '/' }"
                        class="w-100 d-flex align-items-center justify-content-center p-0 py-50"
                      >
                        <feather-icon icon="HomeIcon" size="20" class="mr-1" />
                        <span>Home</span>
                      </b-button>
                    </b-col> -->
                  </b-row>

                  <!-- Divider -->
                  <div class="divider-wrapper my-2">
                    <div class="divider-line" />
                    <span class="divider-text">or</span>
                    <div class="divider-line" />
                  </div>

                  <b-row>
                    <b-col
                      md="12"
                      class="mb-1"
                    >
                      <div class="d-flex align-items-center">
                        <b-form-input
                          v-model="msInstitutionCode"
                          placeholder="Enrolment Code"
                          class="ms-code-input mr-1"
                          @input="microsoftError = null"
                        />
                        <b-button
                          variant="light"
                          class="microsoft-btn d-flex align-items-center justify-content-center p-0 py-50 flex-grow-1"
                          :disabled="
                            !msInstitutionCode || microsoftLoginLoading
                          "
                          @click="loginWithMicrosoft"
                        >
                          <b-spinner
                            v-if="microsoftLoginLoading"
                            small
                            class="mr-1"
                          />
                          <img
                            v-else
                            src="@/assets/images/pages/login/microsoft.svg"
                            alt="Microsoft"
                            width="20"
                            height="20"
                            class="mr-1"
                          >
                          <span>Sign up with Microsoft</span>
                        </b-button>
                      </div>
                      <div
                        v-if="microsoftError"
                        class="text-danger mt-1"
                        style="font-size: 14px"
                      >
                        {{ microsoftError }}
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BSpinner,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'

import { mapGetters, mapActions } from 'vuex'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { validateMicrosoftSignup } from '@/api/system/auth'

export default {
  directives: { 'b-tooltip': VBTooltip },
  components: {
    BSpinner,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      previewImage: null,
      avatar: null,
      institutionCode: '',
      msInstitutionCode: '',
      isLoading: false,
      microsoftLoginLoading: false,
      microsoftError: null,
      status: '',
      password: '',
      confirmPassword: '',
      userEmail: '',
      firstName: '',
      lastName: '',
      sideImg: require('@/assets/images/pages/register.svg'),
      required,
      email,
    }
  },
  computed: {
    ...mapGetters('vrCode', ['load', 'error']),
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    ...mapActions('vrCode', ['login', 'clearError']),
    register_test() {
      const formData = new FormData()
      formData.append('fname', this.firstName)
      formData.append('lname', this.lastName)
      formData.append('email', this.userEmail)
      formData.append('password', this.password)
      formData.append('confirm_password', this.confirmPassword)
      formData.append('avatar', this.avatar)
      formData.append('institution_code', this.institutionCode)
      const payload = { query: formData }
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          this.isLoading = true
          this.$store
            .dispatch('users/register', payload)
            .then(() => {
              this.isLoading = false
              this.$swal({
                icon: 'success',
                title: '<h4>Registration successful! </h4>',
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
              this.$router.push({
                name: 'verify-code',
                query: { email: this.userEmail },
              })
            })
            .catch(error => {
              this.isLoading = false
              if (error.response) {
                const errorMessage = error.response.data.message
                  || error.response.data.error
                  || 'Registration failed'
                this.$swal({
                  icon: 'error',
                  title: `<h4>${errorMessage}</h4>`,
                  showConfirmButton: true,
                  confirmButtonColor: '#7367f0',
                  allowOutsideClick: true,
                })
              }
            })
        }
      })
    },
    async loginWithMicrosoft() {
      this.microsoftLoginLoading = true

      // Validate institution code before opening popup
      try {
        const response = await validateMicrosoftSignup(this.msInstitutionCode)
        if (
          !response
          || typeof response === 'string'
          || response.success !== true
        ) {
          throw new Error(
            response?.error || response?.message || 'Validation failed',
          )
        }
      } catch (error) {
        this.microsoftLoginLoading = false
        let errorMessage = error.message || 'Validation failed'
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message
            || error.response.data.error
            || errorMessage
        }

        this.microsoftError = errorMessage
        return
      }

      const width = 500
      const height = 600
      const left = (window.screen.width - width) / 2
      const top = (window.screen.height - height) / 2
      const url = `${
        process.env.VUE_APP_BASE_URL
      }/login/microsoft?institution_code=${encodeURIComponent(
        this.msInstitutionCode,
      )}`

      const popup = window.open(
        url,
        'microsoft_login',
        `width=${width},height=${height},top=${top},left=${left}`,
      )

      // Check if popup is closed
      const checkPopupClosed = setInterval(() => {
        if (!popup || popup.closed) {
          clearInterval(checkPopupClosed)
          this.microsoftLoginLoading = false
          window.removeEventListener('message', this.onPopupMessage)
        }
      }, 500)

      window.addEventListener('message', this.onPopupMessage)
    },
    onPopupMessage(event) {
      if (event.origin !== window.location.origin) return
      if (event.data.access_token && event.data.user) {
        this.handleSuccessfulLogin(
          event.data.user,
          event.data.access_token,
          event.data.refresh_token,
        )
        window.removeEventListener('message', this.onPopupMessage)
      } else if (event.data.code) {
        this.handleMicrosoftCallback(event.data.code)
        window.removeEventListener('message', this.onPopupMessage)
      }
    },
    async handleMicrosoftCallback(code) {
      try {
        this.microsoftLoginLoading = true
        const response = await this.$store.dispatch(
          'users/msLoginCallback',
          code,
        )
        const token = response.access_token || response.token
        if (response && token) {
          await this.handleSuccessfulLogin(
            response,
            token,
            response.refresh_token,
          )
        } else {
          this.$router.replace('/').catch(() => {})
        }
      } catch (error) {
        console.error('Microsoft Callback Error:', error)
        this.$swal({
          icon: 'error',
          title: 'Login Failed',
          text: 'Failed to sign in with Microsoft.',
          showConfirmButton: true,
          confirmButtonColor: '#7367f0',
        })
        this.microsoftLoginLoading = false
      }
    },
    async handleSuccessfulLogin(userData, token, refreshToken) {
      localStorage.setItem('userData', JSON.stringify(userData))
      localStorage.setItem(useJwt.jwtConfig.storageTokenKeyName, token)
      if (refreshToken) {
        localStorage.setItem(
          useJwt.jwtConfig.storageRefreshTokenKeyName,
          refreshToken,
        )
      }
      if (this.$store.hasModule('auth')) {
        this.$store.commit('auth/SET_USER_DATA', userData)
        this.$store.commit('auth/SET_ACCESS_TOKEN', token)
        if (refreshToken) {
          this.$store.commit('auth/SET_REFRESH_TOKEN', refreshToken)
        }
      }
      if (userData.ability) {
        this.$ability.update(userData.ability)
      }
      const userRole = userData.role || userData.user_type || 'user'
      const homeRoute = getHomeRouteForLoggedInUser(userRole)
      this.$router.replace('/').catch(() => {})
    },
  },
  created() {
    // Check for error parameter from Microsoft redirect
    if (this.$route.query.error) {
      this.$swal({
        icon: 'error',
        title: 'Authentication Error',
        text: decodeURIComponent(this.$route.query.error),
        showConfirmButton: true,
        confirmButtonColor: '#7367f0',
      })
      // Clean up the URL
      this.$router.replace({ query: {} }).catch(() => {})
      return
    }

    if (this.$route.query.code) {
      if (window.opener) {
        window.opener.postMessage(
          { code: this.$route.query.code },
          window.location.origin,
        )
        window.close()
        return
      }
      this.handleMicrosoftCallback(this.$route.query.code)
    } else if (this.$route.query.access_token && this.$route.query.user) {
      let { user } = this.$route.query
      if (typeof user === 'string') {
        try {
          user = JSON.parse(user)
        } catch (e) {
          console.error('Failed to parse user JSON', e)
        }
      }
      if (window.opener) {
        window.opener.postMessage(
          {
            access_token: this.$route.query.access_token,
            refresh_token: this.$route.query.refresh_token,
            user,
          },
          window.location.origin,
        )
        window.close()
        return
      }
      this.handleSuccessfulLogin(
        user,
        this.$route.query.access_token,
        this.$route.query.refresh_token,
      )
    }
  },
}
</script>

<style lang="scss" scoped>
.auth-wrapper {
  background-color: #0a0e17;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-register-form {
  background: transparent;
  border-radius: 20px;
  padding: 2rem;
}

.input-icon-wrapper {
  position: relative;
}

input.form-control {
  background-color: #121826 !important;
  border: none !important;
  border-radius: 12px;
  height: 50px;
  padding-left: 45px !important;
  color: #ffffff !important;
  font-size: 16px;
  box-shadow: none !important;
}

input.form-control:focus {
  outline: none;
  border: 1px solid #3d91f5 !important;
}

.field-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  color: #b8b8b8;
}

.form-control::placeholder {
  color: #b8b8b8 !important;
  font-size: 15px;
}

button.btn-primary {
  background: linear-gradient(90deg, #6c3adf 0%, #23c7ec 100%) !important;
  border: none !important;
  border-radius: 12px;
  height: 50px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

button.btn-primary:hover {
  opacity: 0.9;
}

.btn-secondary {
  background-color: transparent !important;
  color: #ffffff !important;
  border: 1px solid #ffffff40 !important;
  border-radius: 12px;
  height: 50px;
}

.text-danger {
  font-size: 0.8rem;
  margin-top: 5px;
}

.show-pass-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #b8b8b8;
}

.microsoft-btn {
  height: 50px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08) !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-weight: 600;
  font-size: 16px;
  color: #ffffff !important;
  transition: all 0.3s ease;
}

.microsoft-btn:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  box-shadow: 0 4px 15px rgba(108, 58, 223, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
}

.microsoft-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.divider-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
}

.divider-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
}

.divider-text {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  font-weight: 500;
  text-transform: lowercase;
}

.ms-code-input {
  height: 50px;
  border-radius: 12px;
  width: 30%;
  background-color: #121826 !important;
  color: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  padding-left: 15px !important;
  font-size: 16px;
}

.ms-code-input:focus {
  border: 1px solid #3d91f5 !important;
  outline: none;
}

.ms-code-input::placeholder {
  color: #b8b8b8 !important;
}

.register-test-logo {
  // max-width: 200px;
  // height: auto;
  cursor: pointer;
}
</style>
